import { connect } from 'react-redux';

import PresentationSection from './presentation.jsx';

import {
  getAssetForContent,
  getSectionSingletonContentItem
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getHeightStyle
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

const mapStateToProps = (state, { section }) => {
  const contentItem = getSectionSingletonContentItem(state, section);
  const asset = getAssetForContent(state, contentItem);
  const height = getHeightStyle(section);

  if (!contentItem || !asset) {
    return {
      hasContent: false
    };
  }

  return {
    height,
    hasContent: true,
    slides: asset.slides,
    displayFilename: asset.display_filename,
    downloadLink: asset.downloadLink,
    canDownloadAsset: contentItem.can_download_asset
  };
};

const mapDispatchToProps = (dispatch, { section }) => ({
  onDownloadClick: () => {
    getTracker().handlePPTDownloadClick(section.singletonContentUuid);
  },
  onPresentationSlideDisplay: (slideNum) => {
    getTracker().handlePPTSlideDisplayed(section.singletonContentUuid, slideNum);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationSection);
